
import { supabaseWorker } from '@/integrations/supabase/workerClient';

export interface AddressSuggestion {
  value: string;
  unrestricted_value: string;
  data: {
    postal_code?: string;
    country?: string;
    region?: string;
    city?: string;
    street?: string;
    house?: string;
    flat?: string;
  };
}

export interface DaDataResponse {
  suggestions: AddressSuggestion[];
}

export async function fetchAddressSuggestions(query: string): Promise<AddressSuggestion[]> {
  if (!query || query.length < 3) {
    return [];
  }

  try {
    console.log('[fetchAddressSuggestions] Calling dadata-proxy with query:', query);
    
    const { data, error } = await supabaseWorker.functions.invoke('dadata-proxy', {
      body: { 
        query,
        type: 'address'
      }
    });

    if (error) {
      console.error('[fetchAddressSuggestions] Supabase functions error:', error);
      throw error;
    }

    console.log('[fetchAddressSuggestions] DaData response:', data?.suggestions?.length);
    return data?.suggestions || [];
  } catch (error) {
    console.error('[fetchAddressSuggestions] Error:', error);
    // Return mock data for testing if API is not available
    return getMockAddressSuggestions(query);
  }
}

// Mock data for testing when API is not available
function getMockAddressSuggestions(query: string): AddressSuggestion[] {
  const mockAddresses: AddressSuggestion[] = [
    {
      value: 'г Москва, ул Тверская, д 1',
      unrestricted_value: 'г Москва, ул Тверская, д 1',
      data: {
        postal_code: '125009',
        country: 'Россия',
        region: 'Москва',
        city: 'Москва',
        street: 'Тверская',
        house: '1'
      }
    },
    {
      value: 'г Москва, ул Арбат, д 10',
      unrestricted_value: 'г Москва, ул Арбат, д 10',
      data: {
        postal_code: '119019',
        country: 'Россия',
        region: 'Москва',
        city: 'Москва',
        street: 'Арбат',
        house: '10'
      }
    },
    {
      value: 'г Санкт-Петербург, Невский пр-кт, д 28',
      unrestricted_value: 'г Санкт-Петербург, Невский пр-кт, д 28',
      data: {
        postal_code: '191025',
        country: 'Россия',
        region: 'Санкт-Петербург',
        city: 'Санкт-Петербург',
        street: 'Невский пр-кт',
        house: '28'
      }
    }
  ];

  return mockAddresses.filter(addr => 
    addr.value.toLowerCase().includes(query.toLowerCase())
  );
}
